// UI strings for the notes shown with an inflection table (engine rules/paradigm-notes.ts: one
// string per note id). Finnish first; en has the same shape.
import { defineArea } from '../area';

export const paradigmNotesFi = {
  /** īlōnda, jemēla, pōntāla: the "Monikko" column has singular endings (build-020) */
  pluralPersonSingularEndings: 'Monikon persoona, yksikön päätteet.',
};

export const paradigmNotesEn: typeof paradigmNotesFi = {
  pluralPersonSingularEndings: 'Plural person, singular endings.',
};

// Messages.paradigmNotes (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('paradigmNotes', paradigmNotesFi, paradigmNotesEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof paradigmNotesFi> {}
}
